// @ts-ignore
let $ = window.jQuery;

let reload: string | number | NodeJS.Timer;

function getCookie(name: string): string {
    var parts = document.cookie.split(name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();

    return '';
}

function deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function markReloadPendingOnReturn() {
    reload = setInterval(() => {
        let ck = getCookie('reloadCerts');
        if (ck !== '') {
            reloadDataTables();
            clearInterval(reload);
            deleteCookie('reloadCerts');
        }
    }, 500);
}

export function reloadDataTables(resetPaging = false) {
    const table = $('#DataTables_Table_0');
    if (table.length > 0 && ($.fn as any).DataTable.isDataTable(table)) {
        (table as any).DataTable().ajax.reload(function () {
            $('body').trigger('gv_datatables_reloaded');
        }, resetPaging);
    }
}
